<template>
    <b-nav vertical class='pl-3 text-white  gray-back'>
      <div v-for='(links, title) in linkList' :key='title' class="pt-3 gray-back">
        <h5 class="ml-4 mb-2 pb-1 sub-title">{{ title }}</h5>
        <div class="sub-side-color py-2 pl-5">
          <div v-for='linkInfo in links' :key='linkInfo.title' class='text-white  mb-1 mt-1'>
            <router-link :to="linkInfo.url" class='text-white mb-3 font-w300'>
              <b-icon :icon="linkInfo.icon" class='mr-2 icon-size'></b-icon>{{linkInfo.title}}
            </router-link>
          </div>
        </div>
      </div>
    </b-nav>
</template>
<script>
export default {
  data() {
    return {
      nowPath: this.$route.path,
      open: 'true',
      linkList: {
        'クライアント': [
          {
            title: 'クライアントを追加',
            icon: 'plus-circle',
            url: '/agency/add_client'
          },
          {
            title: 'クライアント一覧',
            icon: 'files',
            url: '/agency/client_list'
          },
        ],
        '求人': [
          {
            title: '求人を作成',
            icon: 'plus-circle',
            url: '/agency/jobCreate'
          },
          {
            title: '求人一覧',
            icon: 'files',
            url: '/agency/jobOffers'
          },
        ],
        '応募': [
          {
            title: '承認待ち応募者一覧',
            icon: 'file-person',
            url: '/agency/applicantList'
          },
          {
            title: 'マッチング一覧',
            icon: 'calendar3',
            url: '/agency/matchList'
          },
        ],
        'チャット/面接予定': [
          {
            title: '面接予定',
            icon: 'people',
            url: '/agency/interviews'
          },
          {
            title: 'チャット',
            icon: 'chat-right',
            url: '/agency/mail-box'
          }
        ],
        '設定': [
          {
            title: '代理店情報編集',
            icon: 'gear',
            url: '/agency/startup'
          },
          {
            title: 'ユーザー管理',
            icon: 'people',
            url: '/agency/users'
          },
          {
            title: 'ログアウト',
            icon: 'arrow-bar-left',
            url: '/agency/logout'
          }
        ],
      }
    };
  },
  components: {
  },
  mounted(){
  },

};
</script>
<style scoped lang="scss">
.text-white{
  color: #FFFFFF !important;
}
.sub-side-color{
  background-color: #707589;
}
.icon-size{
  font-size: 1.2rem !important;
}
.font-w300 {
  font-weight: 300;
  font-size: 15px;
}
.sub-title {
  font-size: 16px;
  background-color: #4a4d5a;
  font-weight: 400
}
.gray-back {
  background-color: #4a4d5a;
}
</style>
